import validator from "validator";

export const isURL = (str: string) => validator.isURL(str, { require_tld: false, require_protocol: true });

export function getDomain(url: string): string {
    // Handle null, undefined, or empty strings
    if (!url || typeof url !== "string") {
      return "";
    }

    // Trim whitespace
    url = url.trim();

    // If empty after trim, return empty string
    if (!url) {
      return "";
    }

    try {
      // Try parsing as-is first
      let parsedUrl: URL;

      try {
        parsedUrl = new URL(url);
      } catch (e) {
        // If parsing fails, try adding protocol
        // Check if it looks like a domain (contains a dot and no spaces)
        if (url.includes(".") && !url.includes(" ")) {
          parsedUrl = new URL(`https://${url}`);
        } else {
          // Not a valid URL format, return as-is
          return url;
        }
      }

      // Extract hostname (this handles ports, paths, query params, fragments automatically)
      let hostname = parsedUrl.hostname;

      // Handle empty hostname
      if (!hostname) {
        return url;
      }

      // Remove "www." prefix if it exists (case-insensitive)
      if (hostname.toLowerCase().startsWith("www.")) {
        hostname = hostname.substring(4);
      }

      // Handle IP addresses - return as-is
      if (/^(\d{1,3}\.){3}\d{1,3}$/.test(hostname) || hostname.includes(":")) {
        return hostname;
      }

      // Ensure we have at least one dot (valid domain)
      if (!hostname.includes(".")) {
        return url;
      }

      return hostname;
    } catch (error) {
      // Final fallback: try to extract domain manually
      try {
        // Remove protocol if exists
        let cleaned = url.replace(/^(https?:\/\/)?(www\.)?/i, "");

        // Remove path, query, and fragment
        cleaned = cleaned.split("/")[0].split("?")[0].split("#")[0];

        // Remove port if exists
        cleaned = cleaned.split(":")[0];

        // Return the cleaned domain or original if cleaning failed
        return cleaned || url;
      } catch (fallbackError) {
        return url;
      }
    }
  }

  export function getLinkedinURL(url: string) : string {
    try {
        new URL(url);
        return url
      } catch {
        return `https://linkedin.com/${url}`
      }
  }

  export function getFacebookURL(url: string) : string {
    try {
        new URL(url);
        return url
      } catch {
        return `https://facebook.com/${url}`
      }
  }